<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <!-- <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>-->
      <zj-layout-container class="content video-monitor">
        <div class="leftNav" v-if="!isShowAll">
          <div class="leftSpot"></div>
          <div class="leftNav_title">
            实时视频
            <div class="title_btmLine"></div>
          </div>
          <el-form @submit.native.prevent>
            <el-input
              placeholder="搜索监控点"
              class="nav-tree-filter"
              v-model="filterText"
            ></el-input>
            <div class="nav-tree-content">
              <el-tree
                style="height: 100%"
                v-loading="loading"
                :element-loading-text="loadingText"
                @node-click="nodeClick"
                lazy
                :load="loadNode"
                node-key="id"
                :props="defaultProps"
                :filter-node-method="filterNode"
                class="zj-demo-player-tree-device-tree"
                ref="tree"
              ></el-tree>
            </div>
          </el-form>
        </div>
        <!-- 右侧内容 -->
        <div
          class="rightContent"
          @mouseover="bottomMouseOver()"
          @mouseleave="bottomMouseLeave()"
        >
          <div class="topContent">
            <!-- 分屏是一个的时候开始 -->
            <div class="oneVideoBox" v-if="showtype == '1'">
              <div class="showOneVideo" id="canvas0">
                <div style="width: 100%; height: 100%">
                  <div style="width: 100%; height: 100%">
                    <!-- <flv-player
                      ref="childOneVideo"
                      class="videoBig-item"
                      :url="cameras[0].outUrl"
                      :cameraName="cameras[0].cameraName"
                      viewMode="static"
                      currentIndex="0"
                      :loadMsg="cameras[0].loadMsg"
                      :loadStatus="cameras[0].loadStatus"
                      @destoryVideo="closeVideo"
                      @play="play"
                      @stop="stop"
                    /> -->
                    <flv-player-real-time
                      ref="childOneVideo"
                      class="videoBig-item"
                      :currentIndex="0"
                      :cameraId="cameras[0].cameraId"
                      :cameraName="cameras[0].cameraName"
                      :cameraIsOnline="cameras[0].cameraIsOnline"
                      @destoryVideo="closeVideo"
                      @play="play"
                      @stop="stop"
                    />
                    <!-- <zj-video-player
                      ref="childOneVideo"
                      class="videoBig-item"
                      :url="`http://example.com/flv/video.flv`"
                     
                    /> -->
                  </div>
                </div>
              </div>
              <div class="controlOneVideo" v-if="!isShowAll">
                <div class="leftSpot"></div>
                <div style="display: flex">
                  <div class="control-wrapper">
                    <div
                      class="control-btn control-top"
                      @mousedown="ptzCamera('up')"
                      @mouseup="ptzCamera('stop')"
                    >
                      <i class="el-icon-caret-top"></i>
                      <div class="control-inner-btn control-inner"></div>
                    </div>
                    <div
                      class="control-btn control-left"
                      @mousedown="ptzCamera('left')"
                      @mouseup="ptzCamera('stop')"
                    >
                      <i class="el-icon-caret-left"></i>
                      <div class="control-inner-btn control-inner"></div>
                    </div>
                    <div
                      class="control-btn control-bottom"
                      @mousedown="ptzCamera('down')"
                      @mouseup="ptzCamera('stop')"
                    >
                      <i class="el-icon-caret-bottom"></i>
                      <div class="control-inner-btn control-inner"></div>
                    </div>
                    <div
                      class="control-btn control-right"
                      @mousedown="ptzCamera('right')"
                      @mouseup="ptzCamera('stop')"
                    >
                      <i class="el-icon-caret-right"></i>
                      <div class="control-inner-btn control-inner"></div>
                    </div>
                    <div class="control-round"></div>
                  </div>
                </div>

                <div style="margin-top: 4rem; padding: 0px 3rem">
                  <div class="videoblock">
                    <span class="demonstration">焦距：</span>

                    <el-button
                      icon="el-icon-minus"
                      round
                      @mousedown.native="ptzCamera('zoomout')"
                      @mouseup.native="ptzCamera('stop')"
                    ></el-button>
                    <el-button
                      icon="el-icon-plus"
                      round
                      @mousedown.native="ptzCamera('zoomin')"
                      @mouseup.native="ptzCamera('stop')"
                    ></el-button>
                  </div>
                  <div class="videoblock">
                    <span class="demonstration">速度：</span>
                    <el-slider
                      class="zj_slider"
                      v-model="controSpeed"
                      :max="255"
                    ></el-slider>
                  </div>
                </div>
              </div>
            </div>
            <!-- 分屏是一个的时候结束 -->
            <!-- 分屏是3个 -->
            <!-- <div class="threes" v-if="showtype == '3'">
              <div class="leftBigVideo">
                <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :autoplay="autoplay"
                  :streamType="streamType"
                />
              </div>
              <div class="rightVideo">
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
                <div class="rightbottomvideo">
                  <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  />
                </div>
              </div>
            </div>-->
            <!-- 分屏是3个结束 -->
            <!-- 分屏是4个，第一种开始 &&showtypeIndex=='2'-->
            <div class="threes averaBox" v-if="showtype == '4'">
              <template v-for="(item, index) in cameras">
                <div
                  class="righttopvideo"
                  :key="index"
                  :id="'canvas' + index"
                  :class="{ martop12: index > 1 }"
                >
                  <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div>
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :currentIndex="index"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <flv-player
                    ref="childVideo"
                    class="videoBig-item"
                    :url="item.outUrl"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    :loadMsg="item.loadMsg"
                    :loadStatus="item.loadStatus"
                    @destoryVideo="closeVideo"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是4个，第一种结束 -->
            <!-- 分屏是4个，第二种开始 -->
            <div class="threes" v-if="showtype == '4' && showtypeIndex == '3'">
              <div class="leftBigVideo">
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :id="'canvas' + index"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :cameraIsOnline="cameras[0].cameraIsOnline"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
                <flv-player-real-time
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :currentIndex="0"
                  @destoryVideo="closeVideo"
                />
              </div>
              <div class="rightVideo">
                <div class="rightvideo3">
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :currentIndex="1"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    ref="childVideo"
                    :cameraId="cameras[1].cameraId"
                    :cameraName="cameras[1].cameraName"
                    :cameraIsOnline="cameras[1].cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div
                  class="rightvideo3"
                  style="margin-top: 1rem; margin-bottom: 1rem"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :currentIndex="2"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[2].cameraId"
                    :cameraName="cameras[2].cameraName"
                    :cameraIsOnline="cameras[2].cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div class="rightvideo3">
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="cameras[3].cameraId"
                    :cameraName="cameras[3].cameraName"
                    :currentIndex="3"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="cameras[3].cameraId"
                    :cameraName="cameras[3].cameraName"
                    :cameraIsOnline="cameras[3].cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </div>
            </div>
            <!-- 分屏是4个，第二种结束 -->
            <!-- 分屏是6个，第1种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '4'"
            >
              <div
                class="videoSix"
                v-for="(item, index) in cameras"
                :key="index"
                :id="'canvas' + index"
              >
                <flv-player-real-time
                  ref="childVideo"
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :currentIndex="index"
                  @destoryVideo="closeVideo"
                />
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :cameraIsOnline="item.cameraIsOnline"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
            </div>
            <!-- 分屏是6个，第1种结束 -->
            <!-- 分屏是6个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '6' && showtypeIndex == '5'"
            >
              <div
                class="videoSixtop"
                :id="'canvas' + index"
                :class="{ videoSixtop: index < 2, videoSixbottom: index > 1 }"
                v-for="(item, index) in cameras"
                :key="index"
              >
                <flv-player-real-time
                  ref="childVideo"
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :currentIndex="index"
                  @destoryVideo="closeVideo"
                />
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="item.cameraId"
                  :cameraName="item.cameraName"
                  :cameraIsOnline="item.cameraIsOnline"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
            </div>
            <!-- 分屏是6个，第二种结束 -->
            <!-- 分屏是7个 -->
            <div class="threes averaBox" v-if="showtype == '7'">
              <div class="leftBigVideo">
                <flv-player-real-time
                  ref="childVideo"
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :currentIndex="0"
                  @destoryVideo="closeVideo"
                />
                <!-- <zj-camera-preview
                  class="videoBig-item"
                  :cameraId="cameras[0].cameraId"
                  :cameraName="cameras[0].cameraName"
                  :cameraIsOnline="cameras[0].cameraIsOnline"
                  :autoplay="autoplay"
                  :streamType="streamType"
                /> -->
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div
                    class="rightvideo7"
                    v-if="index != 0"
                    :key="index"
                    :id="'canvas' + index"
                  >
                    <flv-player-real-time
                      ref="childVideo"
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :currentIndex="index"
                      @destoryVideo="closeVideo"
                    />
                    <!-- <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :cameraIsOnline="item.cameraIsOnline"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    /> -->
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是7个结束 -->
            <!-- 分屏是9个 第一种开始 &&showtypeIndex=='7'-->
            <div class="threes averaBox" v-if="showtype == '9'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo9" :id="'canvas' + index" :key="index">
                  <div
                    class="closebtn"
                    @click="closeNowVideo(index)"
                    v-show="item.showClose"
                  ></div>
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是9个 第一种结束-->
            <!-- 分屏是9个，第2种开始 -->
            <div
              class="threes averaBox"
              v-if="showtype == '9' && showtypeIndex == '8'"
            >
              <div
                class="leftBigVideo"
                style="
                  border: none !important;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: space-between;
                "
              >
                <div
                  class="videoSixtop"
                  :class="{
                    videoNinetop: index == 0,
                    videoNinebottom: index == 1 || index == 2,
                  }"
                  v-for="(item, index) in cameras"
                  :key="index"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </div>
              <div class="rightVideo averaBox">
                <template v-for="(item, index) in cameras">
                  <div
                    class="rightvideo7"
                    v-if="index > 2"
                    :key="index"
                    :id="'canvas' + index"
                  >
                    <flv-player-real-time
                      ref="childVideo"
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :currentIndex="index"
                      @destoryVideo="closeVideo"
                    />
                    <!-- <zj-camera-preview
                      class="videoBig-item"
                      :cameraId="item.cameraId"
                      :cameraName="item.cameraName"
                      :cameraIsOnline="item.cameraIsOnline"
                      :autoplay="autoplay"
                      :streamType="streamType"
                    /> -->
                  </div>
                </template>
              </div>
            </div>
            <!-- 分屏是9个，第二种结束 -->
            <!-- 分屏是12个 第一种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '9'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第一种结束-->
            <!-- 分屏是12个 第二种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '12' && showtypeIndex == '10'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo12"
                  :key="index"
                  :class="{ martop12: index > 3 }"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是12个 第二种结束-->
            <!-- 分屏是15个 第1种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '11'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo15"
                  :key="index"
                  :class="{ martop12: index > 4 }"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第1种结束-->
            <!-- 分屏是15个 第2种开始-->
            <div
              class="threes averaBox"
              v-if="showtype == '15' && showtypeIndex == '12'"
            >
              <template v-for="(item, index) in cameras">
                <div
                  class="rightvideo9"
                  :key="index"
                  v-if="index < 3"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
                <div
                  class="rightvideomini"
                  :key="index"
                  :class="{ martop12: index > 2 }"
                  v-if="index > 2"
                  :id="'canvas' + index"
                >
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是15个 第2种结束-->
            <!-- 分屏是16个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '16'">
              <template v-for="(item, index) in cameras">
                <!-- :class="{'martop12':index>3}" -->
                <div class="rightvideo16" :key="index" :id="'canvas' + index">
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是16个 第1种结束-->
            <!-- 分屏是24个 第1种开始-->
            <div class="threes averaBox" v-if="showtype == '24'">
              <template v-for="(item, index) in cameras">
                <div class="rightvideo24" :key="index" :id="'canvas' + index">
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                    
                  /> -->
                  <flv-player-real-time
                    ref="childVideo"
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :currentIndex="index"
                    @destoryVideo="closeVideo"
                  />
                  <!-- <zj-camera-preview
                    class="videoBig-item"
                    :cameraId="item.cameraId"
                    :cameraName="item.cameraName"
                    :cameraIsOnline="item.cameraIsOnline"
                    :autoplay="autoplay"
                    :streamType="streamType"
                  /> -->
                </div>
              </template>
            </div>
            <!-- 分屏是24个 第1种结束-->
          </div>
          <div class="bottomContent" v-if="!isShowAll">
            <!-- 左侧单个视频控制播放 -->
            <!-- <div class="changebofang" v-if="cameras.length == 1">
              <el-tooltip
                class="item"
                effect="dark"
                content="暂停"
                placement="top"
              >
                <div
                  style="width: 1.9rem; height: 2.1rem; cursor: pointer"
                  @click="stopOneVideo"
                >
                  <img
                    style="width: 100%; height: 100%"
                    src="../../../../../../../public/theme/default/img/video/zanting.png"
                    alt
                  />
                </div>
              </el-tooltip>
              <div class="line"></div>
              <el-tooltip
                class="item"
                effect="dark"
                content="播放"
                placement="top"
              >
                <div
                  style="width: 2.1rem; height: 2.1rem; cursor: pointer"
                  @click="startOneVideo"
                >
                  <img
                    style="width: 100%; height: 100%"
                    src="../../../../../../../public/theme/default/img/video/tingzhi.png"
                    alt
                  />
                </div>
              </el-tooltip>
            </div> -->
            <!-- 右侧分屏数量  v-if="cameras.length == 1"-->
            <div class="rightChange">
              <!-- <div @click="changeQPing()" style="margin-right:20px;">全屏按钮</div> -->
              <div class="changeLogo" @click="changeFenqi"></div>
              <div class="line"></div>
              <div
                style="width: 3.1rem; height: 2.2rem; cursor: pointer"
                @click="dbOneVideo"
              >
                <img
                  style="width: 100%; height: 100%"
                  src="../../../../../../../public/theme/default/img/video/fangda.png"
                  alt
                />
              </div>
            </div>

            <ul class="fenpingBox" v-show="showFenqi">
              <li
                class="fenping_one"
                v-for="(item, index) in fenping"
                :key="index"
                @click="changeShowType(item.type, index)"
                :id="'canvas' + index"
              >
                <img :src="item.src" alt />
                <div
                  style="color: #bce1ee; font-size: 1.4rem; text-align: center"
                >
                  {{ item.type }}
                </div>
              </li>
            </ul>
          </div>

          <div>
            <div class="bottomContentXunFu" v-show="showBottom && isShowAll">
              <!-- 右侧分屏数量  v-if="cameras.length == 1"-->
              <div class="rightChangeXunFu">
                <div
                  style="width: 3.1rem; height: 2.2rem; cursor: pointer"
                  @click="dbOneVideo"
                >
                  <img
                    style="width: 100%; height: 100%"
                    src="../../../../../../../public/theme/default/img/video/suoxiao.png"
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- v-show="showBottom && isShowAll" -->
        </div>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";

// const PageSize = 100;
// eslint-disable-next-line no-unused-vars

// import VideoMonitorControl from "../../../Components/Component-VideoMonitorControl";
// import VideoMonitorThree from "../../../Components/Component-VideoThree";
import src1 from "../../../../../../../public/theme/default/img/video/1.png";
// import src2 from "../../../../../../../public/theme/default/img/video/2.png";
import src3 from "../../../../../../../public/theme/default/img/video/3.png";
// import src4 from "../../../../../../../public/theme/default/img/video/4.png";
// import src5 from "../../../../../../../public/theme/default/img/video/5.png";
// import src6 from "../../../../../../../public/theme/default/img/video/.png";
// import src7 from "../../../../../../../public/theme/default/img/video/7.png";
import src8 from "../../../../../../../public/theme/default/img/video/8.png";
// import src9 from "../../../../../../../public/theme/default/img/video/9.png";
// import src10 from "../../../../../../../public/theme/default/img/video/10.png";
// import src11 from "../../../../../../../public/theme/default/img/video/11.png";
// import src12 from "../../../../../../../public/theme/default/img/video/12.png";
// import src13 from "../../../../../../../public/theme/default/img/video/13.png";
// import src14 from "../../../../../../../public/theme/default/img/video/14.png";
// import src15 from "../../../../../../../public/theme/default/img/video/15.png";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
import {
  getEquipmentCode,
  listEquipment,
  listEquipmentArea,
  listEquipmentCategory,
} from "@/api/src/equipment";
export default {
  name: "realTimeVideo",
  controller: "UI",
  action: "RealTimeVideo",
  components: {
    // VideoMonitorControl
  },
  data() {
    return {
      fenping: [
        { type: "1", src: src1 },
        // {"type":"3","src":src2},
        { type: "4", src: src3 },
        // {"type":"4","src":src4},
        // {"type":"6","src":src5},
        // {"type":"6","src":src6},
        // {"type":"7","src":src7},
        { type: "9", src: src8 },
        // {"type":"9","src":src9},
        // {"type":"12","src":src10},
        // {"type":"12","src":src11},
        // {"type":"15","src":src12},
        // {"type":"15","src":src13},
        // {"type":"16","src":src14},
        // {"type":"24","src":src15}
      ],
      isStart: false,
      valueJj: 50, //记录old值，如果当前值大于old值放大，当前值小于old值缩小
      valueCircle: 50,
      oldValueJj: 50, //记录old值，如果当前值大于old值放大，当前值小于old值缩小
      oldCircle: 50,
      showFenqi: false,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      autoplay: true,
      defaultProps: {
        children: "children",
        label: "label",
        status: "status",
        isLeaf: "leaf",
      },
      previewPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      playbackPlayerConfigs: {
        streamType: 1, //0 - 主码流；1 - 子码流
        autoplay: false,
      },
      cameras: [
        {
          cameraId: "",
          cameraName: "",
          cameraIsOnline: false,
          showClose: false,
        },
      ],
      selectPlayerIndex: 0,
      color: ["2ac1ff", "2ac1ff", "#2ac1ff", "2ac1ff", "2ac1ff", "2ac1ff"],
      mc: "",
      Triangle: "",
      showtype: "1", //摆放几个视频
      showtypeIndex: 0,
      isShowAll: false,
      treeClickCount: 0,
      isStoped: false,
      stopIndex: 0,
      stopIndexArray: [],
      showBottom: false,
      equCode: null,
      controSpeed: 80,
    };
  },
  //  computed: {
  //   ...mapGetters([
  //       'isShowbgImg'
  //     ])
  // },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.$store.dispatch("submitIsShowbg", false);

    // this.handleLoad();
    this.logInfo.ActionName = "实时监控查询";
    this.logInfo.LogMessage = "实时监控查询";
    this.logInfo.ModuleName = "视频监控";
    this.logInfo.PageName = "实时监控页面";
    this.addOperationLog();
    // this.theme.header.visiable = false
    // this.theme.sidemenu.visiable = false
  },
  methods: {
    ...mapActions(["submitIsShowbg"]),
    getEquipmentCode() {
      getEquipmentCode("monitorEquipment").then((response) => {
        this.equCode = response.data;
      });
    },
    loadNode(node, resolve) {
      console.log("节点", node, node.level);
      if (node.level === 0) {
        this.getRegionTree(resolve);
      }
      if (
        node.level > 0 &&
        node.data &&
        node.data.children &&
        node.data.children.length > 0
      ) {
        return resolve(node.data.children);
      } else if (node.level > 0 && node.data) {
        this.initMonitor(node.data.code, resolve);
      }
    },

    getRegionTree(resolve) {
      getEquipmentCode("monitorEquipment").then((response) => {
        this.equCode = response.data;
        listEquipmentArea({ categoryCode: this.equCode, pageSize: 100 }).then(
          (response) => {
            const nodes = [];
            if (response.data) {
              response.data.forEach((item) => {
                nodes.push({
                  label: item.areaName,
                  id: item.id,
                  code: item.areaCode,
                  type: "Area",
                });
              });
            }
            resolve(nodes);
          }
        );
      });
    },
    // 获取设备
    initMonitor(areaCode, resolve) {
      this.loading = true;
      listEquipment({
        areaCode: areaCode,
        categoryCode: this.equCode || "monitor",
        pageSize: 10000,
      }).then((response) => {
        const nodes = [];
        if (response.rows) {
          response.rows.forEach((item) => {
            nodes.push({
              label: item.equipmentName,
              id: item.equipmentCode || item.id,
              leaf: true,
              data: item,
              type: "monitor",
              status: item.onlineStatus,
            });
          });
        }
        this.loading = false;
        console.log("设备nodes", nodes);
        resolve(nodes);
      });
    },

    dbOneVideo() {
      if (this.showtype == 1) {
        // 全屏
        this.$refs.childOneVideo.onDblClick();
      } else {
        this.changeQPing();
      }
    },
    changeQPing() {
      this.isShowAll = !this.isShowAll;
      if (this.isShowAll) {
        this.theme.header.visiable = false;
        this.theme.sidemenu.visiable = false;
      } else {
        this.theme.header.visiable = true;
        this.theme.sidemenu.visiable = true;
      }
    },
    closeNowVideo(index) {
      //   this.$refs.childVideo[index].stop();

      this.cameras[index].cameraId = "";
      this.cameras[index].cameraName = "";
      this.cameras[index].cameraIsOnline = false;

      //  if(this.selectPlayerIndex>index){
      this.selectPlayerIndex = index;
      this.isStoped = true;
      this.stopIndex = index;
      this.stopIndexArray.push(this.stopIndex);
      console.log("移除index数组", this.stopIndexArray);

      document
        .getElementById("canvas" + index)
        .getElementsByTagName("canvas")[0]
        .setAttribute("style", "display:none");

      //  }
    },
    clearCanvas(index) {
      // document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("canvas")[0].width = document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("canvas")[0].width;
      // document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("canvas")[0].height = document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("canvas")[0].height;
      let canvas = null;
      document
        .getElementById("canvas" + index)
        .getElementsByTagName("canvas")[0]
        .setAttribute("id", "myCanvas" + index);
      // document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("canvas")[0]
      //   .setAttribute("style", "display:none");
      // var c = document.querySelector("canvas");
      canvas = document.getElementById("myCanvas" + index);
      // canvasRemove.parentNode.removeChild(canvasRemove);
      // var canvasDiv = document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("div")[2]
      //   .setAttribute("id", "preview" + index);
      // var canvasPreview = document.getElementById("preview" + index);
      // var canvas = document.createElement("canvas");
      // canvas.width = 326;
      // canvas.height = 200;
      // canvasPreview.insertBefore(canvas,document
      //   .getElementById("canvas" + index)
      //   .getElementsByTagName("div")[3]);
      console.log(canvas);
      const gl = canvas.getContext("webgl");
      if (!gl) {
        console.log("获取webgl上下文对象失败");
      }
      /*清空画板上的颜色，并初始化颜色*/
      gl.clearColor(0.0, 0.0, 0.0, 1.0);
      //设定canvas初始化时候的深度
      gl.clearDepth(1.0);
      //清空画面上的颜色
      gl.clear(
        gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT | gl.GL_STENCIL_BUFFER_BIT
      );
      // var cxt = c.getContext("webgl");

      // gl.clearColor(36, 129, 223, 1);
      // gl.clear(gl.COLOR_BUFFER_BIT);
    },
    searchEnterFun() {
      alert(1);
    },
    mouseOver(index) {
      this.cameras[index].showClose = true;
    },
    // 移出
    mouseLeave(index) {
      this.cameras[index].showClose = false;
    },
    bottomMouseOver() {
      this.showBottom = true;
    },
    // 移出
    bottomMouseLeave() {
      this.showBottom = false;
    },
    startOneVideo() {
      // 开始播放视频
      this.$refs.childOneVideo.play();
    },
    play() {
      this.isStart = true;
    },
    stop() {
      this.isStart = false;
    },
    stopOneVideo() {
      // 停止播放视频
      this.$refs.childOneVideo.stop();
    },
    changeShowType(type, index) {
      // 改变视频显示个数
      this.showtype = type;
      this.showtypeIndex = index;
      let showtype = Number(this.showtype);
      this.selectPlayerIndex = index;

      let length = this.cameras.length;
      if (length <= showtype) {
        let num = showtype - length;
        for (let i = 0; i < num; i++) {
          let obj = {
            cameraId: "",
            cameraName: "",
            cameraIsOnline: false,
            showClose: false,
          };
          this.cameras.push(obj);
        }
      } else {
        this.cameras.splice(showtype);
      }

      this.showFenqi = false;
    },
    //改变焦距
    changeTopSlider(e) {
      console.log(e);
      if (e > this.oldValueJj) {
        this.Triangle = "ZOOM_IN";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 500);
      } else {
        this.Triangle = "ZOOM_OUT";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 500);
      }
      this.oldValueJj = e;
    },
    zoomInVideo() {
      this.Triangle = "ZOOM_OUT";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 500);
    },
    zoomOutVideo() {
      this.Triangle = "ZOOM_IN";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 500);
    },
    reduceAperture() {
      this.Triangle = "IRIS_ENLARGE";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 1000);
    },
    increaseAperture() {
      this.Triangle = "IRIS_REDUCE";
      this.moveCamera(0);
      setTimeout(() => {
        this.moveCamera(1);
      }, 1000);
    },
    //调整光圈
    changeSlider(e) {
      console.log(e);
      if (e > this.oldCircle) {
        this.Triangle = "IRIS_ENLARGE";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 500);
      } else {
        this.Triangle = "IRIS_REDUCE";
        this.moveCamera(0);
        setTimeout(() => {
          this.moveCamera(1);
        }, 500);
      }
      this.oldCircle = e;
    },
    ptzCamera: function (command) {
      let that = this;
      // if (that.cameras.length == 0 || that.cameras[0].cameraId == "") {
      //   this.$message.warning("请先选择设备");
      //   return;
      // }
      console.log("云台控制：" + command);

      axios({
        method: "post",
        // url: '/api/ptz/' + this.deviceId + '/' + this.channelId + '?leftRight=' + leftRight + '&upDown=' + upDown +
        //     '&inOut=' + zoom + '&moveSpeed=50&zoomSpeed=50'
        url:
          this.CNF("api.monitorGBUrl") +
          "/ptz/control/" +
          this.cameras[0].cameraId +
          "?command=" +
          command +
          "&horizonSpeed=" +
          this.controSpeed +
          "&verticalSpeed=" +
          this.controSpeed +
          "&zoomSpeed=" +
          this.controSpeed,
      }).then(function (res) {});
    },
    //鼠标长按
    chooseTriangle(index) {
      console.log("点击");
      let id = `#innder${index}`;
      // eslint-disable-next-lineno-undef
      $("#wrap")
        .find(".innerSelector")
        .addClass("inner")
        .removeClass("innerSelector");
      $(id).removeClass("inner").addClass("innerSelector");
      if (index == 0) {
        this.Triangle = "UP";
      } else if (index == 1) {
        this.Triangle = "RIGHT_UP";
      } else if (index == 2) {
        this.Triangle = "RIGHT";
      } else if (index == 3) {
        this.Triangle = "RIGHT_DOWN";
      } else if (index == 4) {
        this.Triangle = "DOWN";
      } else if (index == 5) {
        this.Triangle = "LEFT_DOWN";
      } else if (index == 6) {
        this.Triangle = "LEFT";
      } else if (index == 7) {
        this.Triangle = "LEFT_UP";
      }
      if (this.isStart) {
        this.moveCamera(0);
      }
    },
    //鼠标离开事件
    mouseupButton(index) {
      console.log("离开");
      let id = `#innder${index}`;
      // eslint-disable-next-lineno-undef
      $("#wrap")
        .find(".innerSelector")
        .addClass("innerSelector")
        .removeClass("inner");
      $(id).removeClass("innerSelector").addClass("inner");
      this.moveCamera(1);
    },

    nodeoneClick(data, node) {
      let showtype = Number(this.showtype);
      let playerIndex = this.stopIndexArray.indexOf(this.selectPlayerIndex);
      let playerSelectedIndex = this.selectPlayerIndex;
      if (node.level > 1 && node.data.type === "monitor") {
        if (this.cameras && this.cameras[this.selectPlayerIndex]) {
          //寻找播放视频空缺位置
          const selectPreviewIndex = this.cameras.findIndex(
            (p) => p.cameraId == "" || p.cameraId == null
          );
          //当无空缺位置时，按顺序填补
          this.selectPlayerIndex =
            selectPreviewIndex == -1
              ? (this.selectPlayerIndex + 1) % showtype
              : selectPreviewIndex;
          this.cameras[this.selectPlayerIndex].cameraId = data.id;
          this.cameras[this.selectPlayerIndex].cameraName = data.label;
          this.cameras[this.selectPlayerIndex].cameraIsOnline = data.status;
          console.log("监控点击", this.cameras);

          //当选中的index在被停止播放的index中时，清空canvas及恢复canvas的显示（display:""）
          if (this.isStoped && playerIndex > -1) {
            // }, 300);
            //从停止播放的index中，移除已经播放了的index
            const removeIndex =
              this.stopIndexArray.indexOf(playerSelectedIndex);

            if (removeIndex > -1) {
              this.stopIndexArray.splice(removeIndex, 1);
            }
          }

          // debugger;
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function (data, node, self) {
      //记录点击次数
      this.treeClickCount++;
      //单次点击次数超过2次不作处理,直接返回,也可以拓展成多击事件
      if (this.treeClickCount >= 2) {
        return;
      }
      //计时器,计算300毫秒为单位,可自行修改
      this.timer = window.setTimeout(() => {
        if (this.treeClickCount == 1) {
          //把次数归零
          this.treeClickCount = 0;
          //单击事件处理
        } else if (this.treeClickCount > 1) {
          //把次数归零
          this.treeClickCount = 0;
          let showtype = Number(this.showtype);
          let playerIndex = this.stopIndexArray.indexOf(this.selectPlayerIndex);
          let playerSelectedIndex = this.selectPlayerIndex;

          if (node.level > 1 && node.data.type === "monitor") {
            if (this.cameras && this.cameras[this.selectPlayerIndex]) {
              //寻找播放视频空缺位置
              const selectPreviewIndex = this.cameras.findIndex(
                (p) => p.cameraId == "" || p.cameraId == null
              );
              //当无空缺位置时，按顺序填补
              this.selectPlayerIndex =
                selectPreviewIndex == -1
                  ? (this.selectPlayerIndex + 1) % showtype
                  : selectPreviewIndex;
              this.cameras[this.selectPlayerIndex].cameraId = data.id;
              this.cameras[this.selectPlayerIndex].cameraName = data.label;
              this.cameras[this.selectPlayerIndex].cameraIsOnline = data.status;

              //当选中的index在被停止播放的index中时，清空canvas及恢复canvas的显示（display:""）
              if (this.isStoped && playerIndex > -1) {
                //二次清空canvas防止第一次失效情况
                var canvas = document.getElementById(
                  "myCanvas" + playerSelectedIndex
                );
                const gl = canvas.getContext("webgl");
                if (!gl) {
                  console.log("获取webgl上下文对象失败");
                }
                /*清空画板上的颜色，并初始化颜色*/
                gl.clearColor(0.0, 0.0, 0.0, 1.0);
                //设定canvas初始化时候的深度
                gl.clearDepth(1.0);
                //清空画面上的颜色
                gl.clear(
                  gl.COLOR_BUFFER_BIT |
                    gl.DEPTH_BUFFER_BIT |
                    gl.GL_STENCIL_BUFFER_BIT
                );
                // setTimeout(() => {
                document
                  .getElementById("canvas" + playerSelectedIndex)
                  .getElementsByTagName("canvas")[0]
                  .setAttribute("style", "");
                // }, 300);
                //从停止播放的index中，移除已经播放了的index
                const removeIndex =
                  this.stopIndexArray.indexOf(playerSelectedIndex);

                if (removeIndex > -1) {
                  this.stopIndexArray.splice(removeIndex, 1);
                }
              }

              // debugger;
            }
          }
        }
      }, 300);
    },
    closeVideo(index) {
      this.$set(this.cameras, index, {
        outUrl: "",
        cameraName: "",
        cameraId: "",
      });
      this.isStart = false;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    onBack: function () {
      this.$emit("handlerclose");
    },
    changeFenqi() {
      this.showFenqi = !this.showFenqi;
    },
    // 成功连接到媒体中心
    onConnected() {
      console.log("链接成功");
    },
    // 接收到媒体中心的响应
    onRecv(e) {
      console.log("回应");
      console.log(e);
    },
    startCamera() {
      this.isStart = true;
      this.moveCamera(0);
    },
    pauseCamera() {
      this.isStart = false;
      this.moveCamera(1);
    },
    moveCamera(action) {
      if (this.Triangle == "") {
        this.$message({
          type: "alert",
          message: "没有选择摄像机移动方向",
        });
        return;
      }
      var PTZCmds = {
        UP: 21, // 上转
        DOWN: 22, // 下转
        LEFT: 23, // 左转
        RIGHT: 24, // 右转
        LEFT_UP: 25, // 左上
        LEFT_DOWN: 27, // 左下
        RIGHT_UP: 26, // 右上
        RIGHT_DOWN: 28, // 右下
        ZOOM_IN: 13, // 焦距变大
        ZOOM_OUT: 14, // 焦距变小
        FOCUS_NEAR: 11, // 焦点前移
        FOCUS_FAR: 12, // 焦点后移
        IRIS_ENLARGE: 15, // 光圈扩大
        IRIS_REDUCE: 16, // 光圈缩小
        GOTO_PRESET: 39, // 跳转到预置点 （param 需设置为预置点的 ID）
      };
      let id = this.cameras[0].cameraId;
      let command = this.Triangle;
      let params = {
        cameraId: id, //摄像机 ID
        command: PTZCmds[command], //云台命令，参考 PTZCmds 的定义
        action: action, //启动/停止：0 - 启动, 1 - 停止
        speed: 50, //云台速度, 取值范围为1-100
        param: 0, //控制参数, 目前，仅 PTZCmds.GOTO_PRESET 命令需要此参数
      };
      // let params2 = {
      //   cameraId: id, //摄像机 ID
      //   command: PTZCmds[command], //云台命令，参考 PTZCmds 的定义
      //   action: 1, //启动/停止：0 - 启动, 1 - 停止
      //   speed: 50, //云台速度, 取值范围为1-100
      //   param: 0, //控制参数, 目前，仅 PTZCmds.GOTO_PRESET 命令需要此参数
      // };
      console.log("params");
      console.log(params);
      if (this.mc.$connected) {
        //TODO: 直接下发控制指令
        console.log(MSG);
        this.mc.sendCmd(MSG.PTZ_CONTROL, params);
        // setTimeout(() => {
        //   this.mc.sendCmd(MSG.PTZ_CONTROL, params2);
        // },100);
      } else {
        this.mc.connect().then(() => {
          //TODO: 下发控制指令
          this.mc.sendCmd(MSG.PTZ_CONTROL, params);
          // setTimeout(() => {
          //   this.mc.sendCmd(MSG.PTZ_CONTROL, params2);
          // },100);
        });
      }
    },
    // moveCamera(action, from) {
    //   if (this.Triangle == "") {
    //     this.$message({
    //       type: "alert",
    //       message: "没有选择摄像机移动方向",
    //     });
    //     return;
    //   }
    //   if (from == "ischange") {
    //     if (action == 0) {
    //       this.isStart = false;
    //     } else if (action == 1) {
    //       this.isStart = true;
    //     }
    //   }

    //   var PTZCmds = {
    //     UP: 21, // 上转
    //     DOWN: 22, // 下转
    //     LEFT: 23, // 左转
    //     RIGHT: 24, // 右转
    //     LEFT_UP: 25, // 左上
    //     LEFT_DOWN: 27, // 左下
    //     RIGHT_UP: 26, // 右上
    //     RIGHT_DOWN: 28, // 右下
    //     ZOOM_IN: 13, // 焦距变大
    //     ZOOM_OUT: 14, // 焦距变小
    //     FOCUS_NEAR: 11, // 焦点前移
    //     FOCUS_FAR: 12, // 焦点后移
    //     IRIS_ENLARGE: 15, // 光圈扩大
    //     IRIS_REDUCE: 16, // 光圈缩小
    //     GOTO_PRESET: 39, // 跳转到预置点 （param 需设置为预置点的 ID）
    //   };
    //   let id = this.cameras[0].cameraId;
    //   let command = this.Triangle;
    //   let params = {
    //     cameraId: id, //摄像机 ID
    //     command: PTZCmds[command], //云台命令，参考 PTZCmds 的定义
    //     action: action, //启动/停止：0 - 启动, 1 - 停止
    //     speed: 50, //云台速度, 取值范围为1-100
    //     param: 0, //控制参数, 目前，仅 PTZCmds.GOTO_PRESET 命令需要此参数
    //   };
    //    console.log("params");
    //    console.log(params);
    //   if (this.mc.$connected) {
    //     //TODO: 直接下发控制指令
    //     console.log(MSG);
    //    // this.mc.sendCmd(MSG.PTZ_CONTROL, params);
    //   } else {
    //     this.mc.connect().then(() => {
    //       //TODO: 下发控制指令
    //     //  this.mc.sendCmd(MSG.PTZ_CONTROL, params);
    //     });
    //   }
    // },
  },
  beforeDestroy() {
    this.theme.sidemenu.visiable = true;
    this.$store.dispatch("submitIsShowbg", true);
  },
};
</script>
<style lang="scss" scoped>
.videoblock {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 7rem;
}
</style>
